import API_URLS from '../../constants/api-urls';
import { WishlistAuth } from './query-keys/query-keys';

// The wishlist list and its count must always look fresh — "fresh" data class (staleTime 0).
export const WISHLIST_STALE_TIME = 0;
export const WISHLIST_GC_TIME = 5 * 60_000;

// Deliberate exception to the "fresh" data class: a membership answer changes only through a toggle, and this tab's
// own toggles rewrite the cached answer at once. A staleTime above zero keeps a remount refetch from overwriting a
// toggle still in flight; one minute covers that request many times over, while a toggle made in another tab or on
// another device shows up on the first remount after this long.
export const WISHLIST_MEMBERSHIP_STALE_TIME = 60_000;
export const WISHLIST_MEMBERSHIP_GC_TIME = 10 * 60_000;

export const WISHLIST_QUERY_URLS: Record<WishlistAuth, string> = {
    user: `${API_URLS.WISHLIST}/query`,
    anonymous: `${API_URLS.ANONYMOUS_WISHLIST}/query`
};
